import { render, staticRenderFns } from "./ClockListener.vue?vue&type=template&id=a27fb248&"
import script from "./ClockListener.vue?vue&type=script&lang=js&"
export * from "./ClockListener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports